import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { IdentityProviderRequest } from "../../shared/identity-provider-request";
import { DataService_SSO } from "../../shared/data.service";

@Component({
	selector: "app-modify-idp",
	templateUrl: "./modify-idp.component.html",
	styleUrls: ["./modify-idp.component.css"],
})
export class ModifyIDPComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: DataService_SSO
	) {}
	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;

		if (this.EditMode == true) {
			this.IdentityProviderID = this.dialogConfig.data.IdentityProviderID;
			this.IdentityProviderCD = this.dialogConfig.data.IdentityProviderCD;
			this.IdentityProviderDesc = this.dialogConfig.data.IdentityProviderDesc;
			this.LoginButtonDesc = this.dialogConfig.data.LoginButtonDesc;
			this.LoginButtonBackground = this.dialogConfig.data.LoginButtonBackground;
			this.LoginButtonForeground = this.dialogConfig.data.LoginButtonForeground;
			this.LoginButtonIconLink = this.dialogConfig.data.LoginButtonIconLink;
			this.LoginButtonLink = this.dialogConfig.data.LoginButtonLink;
			this.LogoutButtonLink = this.dialogConfig.data.LogoutButtonLink;
			this.ZOrder = this.dialogConfig.data.ZOrder;
			this.Active = this.dialogConfig.data.Active;
		}
	}

	//////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////

	EditMode: boolean = false;

	IdentityProviderID: number = -1;
	IdentityProviderCD: string = "";
	IdentityProviderDesc: string = "";
	LoginButtonDesc: string = "";
	LoginButtonBackground: string = "#1C84C6";
	LoginButtonForeground: string = "#FFFFFF";
	LoginButtonIconLink: string = "";
	LoginButtonLink: string = "";
	LogoutButtonLink: string = "";
	ZOrder: number = -1;
	Active: boolean = true;

	Processing: boolean = false;
	errorMessage: string = "";

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////

	onSave() {
		this.errorMessage = "";

		//
		//	Error Handling
		//
		if (this.IdentityProviderCD == undefined || this.IdentityProviderCD == "") {
			this.errorMessage = "Enter an abbreviation/code";
			return;
		}
		if (this.IdentityProviderDesc == undefined || this.IdentityProviderDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		}
		if (this.LoginButtonLink == undefined || this.LoginButtonLink == "") {
			this.errorMessage = "Enter a link to the CAASS.SSO endpoint that it should call";
			return;
		}

		//
		//	Make WS Request
		//
		this.Processing = true;

		var parms: IdentityProviderRequest = {
			IdentityProviderID: this.IdentityProviderID,
			IdentityProviderCD: this.IdentityProviderCD,
			IdentityProviderDesc: this.IdentityProviderDesc,
			LoginButtonDesc: this.LoginButtonDesc,
			LoginButtonBackground: this.LoginButtonBackground,
			LoginButtonForeground: this.LoginButtonForeground,
			LoginButtonIconLink: this.LoginButtonIconLink,
			LoginButtonLink: this.LoginButtonLink,
			LogoutButtonLink: this.LogoutButtonLink,
			ZOrder: this.ZOrder,
			Active: this.Active,
		};

		var result = this.dataService.IdentityProviderModify(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "idpmodify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "IDP was " + (this.EditMode == true ? "Updated" : "Added") + " Successfully. ",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "idpmodify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not " + (this.EditMode == true ? "update" : "add") + " the IDP: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	//////////////////////////////////////////////////////
}
